// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/share-si-ha-documentation-request-schema',
  type: 'object',
  required: ['sendToEmailAddress', 'shareLink', 'id'],
  properties: {
    sendToEmailAddress: {
      type: 'string',
      format: 'email',
      minLength: 1,
    },
    shareLink: {
      type: 'string',
      minLength: 1,
    },
    id: {
      type: 'integer',
    },
  },
} as IJSONSchema;

export default schema;
